const state = () => ({
  customerList: [],
  trackCalendar: [],
  listOnCalendar: []
})

const mutations = {
  getCustomerList: (state, data) => {
    return (state.customerList = data)
  },
  getcalendaList: (state, data) => {
    return (state.trackCalendar = data)
  },
  getListOnCalendar: (state, data) => {
    return (state.listOnCalendar = data)
  }
}

const actions = {
  getListOfCalendar({ commit }, { month, shop_id, user_id, year }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('month', month)
      fommData.append('user_id', user_id)
      fommData.append('year', year)
      fetch(`${window.baseAPINew}/web/?act=carlendar_customer_list`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getcalendaList', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getListOfVisitDay({ commit }, { date, shop_id, user_id }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('date', date)
      fommData.append('user_id', user_id)
      fetch(`${window.baseAPINew}/web/?act=customerList_oncalendar`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getListOnCalendar', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getListOfCustomer({ commit }, { shop_id, user_id, keyword }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('user_id', user_id)
      fommData.append('keyword', keyword)
      fetch(`${window.baseAPINew}/web/?act=list_customer`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getCustomerList', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const getters = {
  getCustomerList: (state) => (page) => {
    const customerList = state.customerList
    let currentPage = page ? page : 1
    let numberPerPage = 100
    let numberOfPages = customerList.length > 0 ? Math.ceil(customerList.length / 5) : 0
    let pageStart = (currentPage - 1) * numberPerPage
    let pageEnd = numberPerPage + pageStart
    let pageList = customerList.slice(pageStart, pageEnd)
    return pageList
  },
  getMonthCalendar: (state) => {
    const groupTrack = state.trackCalendar.reduce((groups, date) => {
      // Group date data
      let dateTime = date.date_visit.split(' ')[0] // Split Date and Time

      if (!groups[dateTime]) {
        groups[dateTime] = []
      }
      // let findIndexType = groups[dateTime].findIndex(data => data.type == date.status) // Find index of type

      // if(findIndexType != -1){ // Index found
      //   groups[dateTime][findIndexType]['counter'] += 1
      // }
      // else{
      let setcolor = date.color ? date.color : '#cccccc'
      groups[dateTime].push({
        category: date.status,
        type: date.status,
        counter: 1,
        user_id: date.user_id,
        id: date.id,
        color: setcolor
      })

      /************ Mockup ******************/
      /*
            groups[dateTime].push({category : 1, type : 1, counter:1, user_id : date.user_id, id : date.id, isCircle : 1, color : date.color}) 
            groups[dateTime].push({category : 2, type : 2, counter:2, user_id : date.user_id, id : date.id, isCircle : 0, color : date.color}) 
            groups[dateTime].push({category : 3, type : 3, counter:3, user_id : date.user_id, id : date.id, isCircle : 1, color : date.color}) 
            groups[dateTime].push({category : 4, type : 4, counter:4, user_id : date.user_id, id : date.id, isCircle : 0, color : date.color}) 
        */
      /************ Mockup ******************/
      // }

      return groups
    }, {})

    return groupTrack
  },
  getWeekCalendar: (state) => {
    const groupTrack = state.trackCalendar.reduce((groups, date) => {
      // Group date data
      let dateData = date.date_visit.split(' ')[0] // Split Date
      let dateTime = date.date_visit.split(' ')[1].split(':') // Split Time
      dateTime = dateTime[0] + ':' + dateTime[1] // Convert 00:00:00 to 00:00

      // Group date
      if (!groups[dateData]) {
        groups[dateData] = {}
      }

      // Group time
      if (!groups[dateData][dateTime]) {
        groups[dateData][dateTime] = []
      }
      const category = ['รอการเข้าเยี่ยม', 'เข้าเยี่ยมเเล้ว', 'กำลังเช็คอิน']
      groups[dateData][dateTime].push({
        end: '00:00',
        lengthTime: 1,
        type: date.status,
        type_name: category[date.status],
        name: 'ร้าน BB Construc...'
      })

      return groups
    }, {})
    return groupTrack
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
